/* eslint-disable multiline-ternary */
import Header from 'src/components/header/Header';
import { BackNavigation, InfiniteScroll, Loader } from 'src/components/common';
import './venturedetailpage.scss'
import VentureDetail from 'src/components/venture/venture-detail/VentureDetail';
import AboutFounderCard from 'src/components/cards/venture-cards/AboutFounderCard';
import { useEffect } from 'react';
import { useGetIdentity, useUrlParamValue } from 'src/hooks';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { clearComments, clearFocusPoint, clearReplies, clearSingleVenture, clearVentureList, getSingleVenture, getVentureList } from 'src/store/venture/venture.slice';
import { useNavigate } from 'react-router-dom';
import CreateVentureComment from 'src/components/venture/createComment/CreateComment';
import { TVentureRequest } from 'src/services/apiEndpoint.types.ts/ventures/ventures.types';

export type TfilterProps = { endDate: string, programType: string[], industry: string[] }
const VentureDetailPage = () => {
  const { getIdentities } = useGetIdentity();
  const dispatch = useAppDispatch();
  const { singleVenture, ventureLoading } = useAppSelector(
    (store) => store.venture
  );
  const { paramValue } = useUrlParamValue();
  const id: string = paramValue({ paramName: 'id' }) as string;
  const { authenticatedId, loggedInUserType } = getIdentities();
  useEffect(() => {
    if (id) {
      dispatch(getSingleVenture({ id, ...(!authenticatedId ? {} : loggedInUserType === 'Company' ? { companyId: authenticatedId } : { userId: authenticatedId }) }))
    }
    return () => {
      dispatch(clearSingleVenture())
    }
  }, [id, authenticatedId]);
  const fetchListVenture = () => {
    const payload: TVentureRequest = {
      limit: 5,
      page: 1,
      domain: singleVenture?.domain,
      ventureStage: singleVenture?.ventureStage,
      fundingStage: singleVenture?.fundingStage
    }
    dispatch(getVentureList(payload))
  };

  useEffect(() => {
    if (singleVenture) {
      fetchListVenture()
    }

    return () => {
      dispatch(clearVentureList())
      dispatch(clearReplies());
      dispatch(clearComments());
    }
  }, [singleVenture])

  return (
    <>
      <InfiniteScroll
        className="venture-detail"
        onScrollEnd={() => { }}
        loading={false}
        showLoader={false}
        showFooter={false}
        moreItemsLeft={false}
      >
        <Header />
        <div className="venture-detail__body venture-detail__newBody">
          {!ventureLoading && singleVenture && <>
            <div className="venture-detail__body__feed">
              {/* <BackNavigation text='Back' onClick={() => navigate(-1)} /> */}
              <VentureDetail key={singleVenture?.id || 'view-venture'} />
            </div>

            <div className="venture-detail__cards">
              <AboutFounderCard />
            </div>
          </>}

          {ventureLoading && <Loader />}
          {!ventureLoading && !singleVenture && (
            <div className="venture-detail__body__feed">
              <p>No Venture Yet!</p>
            </div>
          )}
        </div>
      </InfiniteScroll>
    </>
  );
};

export default VentureDetailPage;
